import { defineNuxtPlugin } from '#app'

interface ErrorNotification {
  url: string;
  errorType: string;
  errorMessage: string;
}

export default defineNuxtPlugin((nuxtApp) => {
    // Behandlung von Fehlernyarn 
    nuxtApp.vueApp.config.errorHandler = (error: unknown, instance: any, info: string) => {
      console.error('Global error caught:', error);
      notifyAdminAboutIssue(error, 'error');
    };
  
    // Behandlung von Warnungen
    nuxtApp.vueApp.config.warnHandler = (msg: string, instance: any, trace: string) => {
      console.warn('Global warning caught:', msg);
      notifyAdminAboutIssue(msg, 'warning');
    };
  
    // Behandlung von unbehandelten Promise-Ablehnungen
    if (process.client) {
      window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
        console.error('Unhandled promise rejection:', event.reason);
        notifyAdminAboutIssue(event.reason, 'error');
      });
    }
  });
  
  // Gemeinsame Funktion für die Benachrichtigung über Fehler und Warnungen
  function notifyAdminAboutIssue(issue: unknown, type: 'error' | 'warning') {
    const errorType = issue instanceof Error ? issue.name : (type === 'error' ? 'Unknown Error' : 'Warning');
    const errorMessage = issue instanceof Error ? issue.message : String(issue);
  
    fetch(`${import.meta.env.VITE_WP_BASE_URL}/wp-json/fa/v1/notify-issue`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': import.meta.env.VITE_WP_TOKEN as string
      },
      body: JSON.stringify({
        url: window.location.href,
        type: type,
        errorType: errorType,
        errorMessage: errorMessage
      })
    })
    .catch(fetchError => console.error('Error sending notification:', fetchError));
  }